import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';


// render
ReactDOM.render((
  <App />
), document.getElementById('howtobuy'));
